import React from 'react';
import {
  CELERITY,
  MIGHT,
  FORTITUDE,
  SUSTENANCE,
  SORCERY,
  BRANCHES,
  CELERITY_MAP,
  SORCERY_MAP,
  SUSTENANCE_MAP,
  MIGHT_MAP,
  FORTITUDE_MAP
} from './constants';
import './overview.scss';

const STAT_KEYS = [
  "LVL",
  "SUM",
  "HP",
  "ATK",
  "DEF",
  "HP%",
  "ATK%",
  "DEF%",
  "MSPD",
  "DODGE",
  "CRIT",
  "LL",
  "ACC",
];

export default ({
  celerityLevel,
  fortitudeLevel,
  mightLevel,
  sorceryLevel,
  sustenanceLevel,
}) => {
 
  const levelMap = {
    [SUSTENANCE]: SUSTENANCE_MAP[sustenanceLevel],
    [CELERITY]:   CELERITY_MAP[celerityLevel],
    [SORCERY]:    SORCERY_MAP[sorceryLevel],
    [MIGHT]:      MIGHT_MAP[mightLevel],
    [FORTITUDE]:  FORTITUDE_MAP[fortitudeLevel],
  }
  return (
    <div id="overview">
      <table>
        <thead>
          <tr>
            <th className='key'>Stat</th>
            {BRANCHES.map(branch => <th className={branch} key={branch}>{branch}</th>)}
          </tr>
          {STAT_KEYS.map(key => (
            <tr key={key}>
              <td className='key'>{key}</td>
              {BRANCHES.map(branch => (
                <td className={branch} key={`${branch}-${key}`}>
                  {levelMap[branch][key] || '-'}
                </td>
              ))}
            </tr>
          ))}
        </thead>
      </table>
    </div>
  );
};
